/**
 * Neutral storage data types — extracted from the (now-removed) Dexie service so
 * components and services can depend on the shape without pulling in any
 * particular backend.
 */

export interface ConfigurationItem {
  key?: string;
  value: any;
}

export interface RunItem {
  /** `${environment}/${flowName}/${id}` */
  key: string;

  name?: string;
  flowName?: string;
  environment?: string;
  user: string;

  startTime: Date;
  endTime: Date;
  status: string;

  triggerName: string;
  triggerData?: any;
  triggerTest: boolean;
  error?: any;
}

export interface FlowItem {
  /** `${environment}/${flowName}` */
  key: string;

  flowName: string;
  displayName: string;
  environment: string;
  user: string;
  admin?: string;

  backgroundColor: string;
  flowState: string;
  modified: Date;
  sharingType?: string;
  description?: string;
  triggers: any[];
  userType: string;
  owners: any[];
  actionsCount: number;
  actionsTooltip: string;

  definition?: any;
  triggerUrl?: string;
  solution?: string;
  workflowEntityId?: string;
  flowSuspensionReason?: string;
  nextLink?: string;
  favourite?: boolean;

  monitored?: boolean;
  scanned?: Date;
}

export interface UserItem {
  key: string;
  displayName: string;
  /** Primary / canonical display email. */
  email: string;
  /** All known email addresses for this user (includes `email`). Used for multi-alias lookups. */
  emails: string[];
}

/** Ensures the canonical email is always present in the emails array. */
export function mergeEmails(emails: string[] | undefined, primary: string): string[] {
  const base = emails?.length ? [...emails] : [];
  if (primary && !base.includes(primary)) {
    base.unshift(primary);
  }
  return base.filter(Boolean);
}
